import { render, staticRenderFns } from "./feedback-comp.vue?vue&type=template&id=49e13157&scoped=true&"
import script from "./js/feedback-comp.js?vue&type=script&lang=js&"
export * from "./js/feedback-comp.js?vue&type=script&lang=js&"
import style0 from "./feedback-comp.vue?vue&type=style&index=0&id=49e13157&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e13157",
  null
  
)

export default component.exports